import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowRight, CheckCircle, Phone, Shield, Clock, Wrench, AlertCircle } from 'lucide-react';
import ContactForm from '../components/ContactForm';
import { services } from '../data/mockData';

const ServicePage = () => {
  const { serviceId } = useParams();
  const service = services.find(s => s.id === serviceId);

  if (!service) {
    return (
      <div className="container" style={{ padding: '100px 20px' }}>
        <h1>Услуга не найдена</h1>
        <Link to="/" className="btn-primary">Вернуться на главную</Link>
      </div>
    );
  }

  // Main SEO-optimized page for "Ремонт газового котла"
  if (service.id === 'remont-gazovogo-kotla') {
    return (
      <div className="service-page seo-page">
        {/* Breadcrumbs */}
        <div className="breadcrumbs">
          <div className="container">
            <Link to="/">Главная</Link> / <Link to="/services">Услуги</Link> / <span>{service.title}</span>
          </div>
        </div>

        {/* Hero Section */}
        <section className="service-hero">
          <div className="container">
            <div className="service-hero-content">
              <h1 className="seo-h1">{service.title} в Ташкенте: Профессиональный Ремонт с Гарантией</h1>
              <p className="service-lead">
                Срочный ремонт газовых котлов всех марок в Ташкенте и Узбекистане. Выезд мастера в течение 1-2 часов. 
                Работаем 24/7 без выходных. Гарантия на все виды работ до 2 лет.
              </p>
              <div className="service-cta-buttons">
                <a href="tel:+998904886333" className="btn-primary">
                  <Phone size={20} />
                  Вызвать мастера сейчас
                </a>
                <span className="price-highlight">Цена {service.price}</span>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing Section - Landing Style */}
        <section className="pricing-section">
          <div className="container">
            <h2>Цены на ремонт газового котла в Ташкенте</h2>
            <p className="pricing-subtitle">Прозрачные цены без скрытых платежей. Оплата после выполнения работ.</p>
            
            <div className="pricing-grid">
              <div className="pricing-card featured">
                <div className="pricing-badge">Популярно</div>
                <h3>Базовый ремонт</h3>
                <div className="pricing-value">
                  <span className="price-from">от</span>
                  <span className="price-amount">199 000</span>
                  <span className="price-currency">сум</span>
                </div>
                <ul className="pricing-features">
                  <li><CheckCircle size={18} /> Диагностика бесплатно</li>
                  <li><CheckCircle size={18} /> Устранение неисправностей</li>
                  <li><CheckCircle size={18} /> Замена расходников</li>
                  <li><CheckCircle size={18} /> Гарантия 6 месяцев</li>
                </ul>
                <a href="tel:+998904886333" className="btn-primary">Заказать</a>
              </div>

              <div className="pricing-card">
                <h3>Диагностика</h3>
                <div className="pricing-value">
                  <span className="price-from">от</span>
                  <span className="price-amount">99 000</span>
                  <span className="price-currency">сум</span>
                </div>
                <ul className="pricing-features">
                  <li><CheckCircle size={18} /> Выезд мастера</li>
                  <li><CheckCircle size={18} /> Полная диагностика</li>
                  <li><CheckCircle size={18} /> Определение проблемы</li>
                  <li><CheckCircle size={18} /> Консультация специалиста</li>
                </ul>
                <p className="pricing-note">* При заказе ремонта – бесплатно</p>
              </div>

              <div className="pricing-card">
                <h3>Срочный выезд</h3>
                <div className="pricing-value">
                  <span className="price-from">от</span>
                  <span className="price-amount">149 000</span>
                  <span className="price-currency">сум</span>
                </div>
                <ul className="pricing-features">
                  <li><CheckCircle size={18} /> Приезд в течение часа</li>
                  <li><CheckCircle size={18} /> Работа в выходные</li>
                  <li><CheckCircle size={18} /> Ночные вызовы</li>
                  <li><CheckCircle size={18} /> Приоритетное обслуживание</li>
                </ul>
              </div>

              <div className="pricing-card">
                <h3>Капитальный ремонт</h3>
                <div className="pricing-value">
                  <span className="price-from">от</span>
                  <span className="price-amount">499 000</span>
                  <span className="price-currency">сум</span>
                </div>
                <ul className="pricing-features">
                  <li><CheckCircle size={18} /> Полная разборка котла</li>
                  <li><CheckCircle size={18} /> Замена узлов</li>
                  <li><CheckCircle size={18} /> Чистка и настройка</li>
                  <li><CheckCircle size={18} /> Гарантия до 2 лет</li>
                </ul>
              </div>
            </div>

            <div className="pricing-trust-badges">
              <div className="trust-badge">
                <Shield size={24} />
                <span>Цена ниже среднерыночной</span>
              </div>
              <div className="trust-badge">
                <CheckCircle size={24} />
                <span>Без скрытых платежей</span>
              </div>
              <div className="trust-badge">
                <Clock size={24} />
                <span>Оплата после диагностики</span>
              </div>
            </div>
          </div>
        </section>

        {/* Main SEO Content */}
        <section className="seo-content">
          <div className="container">
            <div className="content-layout">
              <div className="main-content">
                <h2>Почему газовый котёл требует профессионального ремонта в Ташкенте</h2>
                <p>
                  Газовый котёл – это сложное технологическое оборудование, обеспечивающее тепло и комфорт в вашем доме. 
                  В условиях климата Узбекистана, где зимой температура может опускаться значительно ниже нуля, 
                  исправная работа отопительной системы становится критически важной для комфортного проживания.
                </p>
                <p>
                  Современные газовые котлы оснащены сложной электроникой, системами автоматики и безопасности. 
                  Любая неисправность требует квалифицированного подхода и профессионального ремонта. 
                  Попытки самостоятельного ремонта газового оборудования не только опасны, но и могут привести к 
                  серьёзным последствиям, включая утечку газа, пожар или полный выход котла из строя.
                </p>

                <h2>Основные причины поломок газовых котлов</h2>
                <p>
                  За годы работы в сфере ремонта отопительного оборудования в Ташкенте и регионах Узбекистана, 
                  наши специалисты выявили типичные причины выхода из строя газовых котлов:
                </p>

                <h3>1. Проблемы с системой циркуляции</h3>
                <p>
                  Одна из самых распространённых причин неисправностей – нарушение циркуляции теплоносителя. 
                  Это может быть вызвано загрязнением теплообменника накипью, особенно актуально для Ташкента, 
                  где вода имеет повышенную жёсткость. Накипь снижает теплопередачу, увеличивает расход газа 
                  и может привести к перегреву котла.
                </p>
                <p>
                  Также циркуляционный насос может выйти из строя из-за износа подшипников или заклинивания ротора. 
                  В этом случае теплоноситель перестаёт двигаться по системе, котёл перегревается и отключается 
                  по аварийному сигналу.
                </p>

                <h3>2. Неисправности электроники и автоматики</h3>
                <p>
                  Современные газовые котлы управляются сложными электронными платами. Скачки напряжения, 
                  которые не редкость в наших электросетях, могут вывести из строя плату управления. 
                  При этом котёл может вообще не включаться, показывать ошибки или работать нестабильно.
                </p>
                <p>
                  Датчики температуры, давления, протока также могут давать сбои. Неправильные показания датчиков 
                  приводят к некорректной работе автоматики, частому включению и выключению котла, 
                  невозможности набрать нужную температуру.
                </p>

                <h3>3. Проблемы с системой розжига и горелкой</h3>
                <p>
                  Котёл может не зажигаться из-за неисправности электродов розжига, проблем с газовым клапаном 
                  или засорения форсунок горелки. Качество газа в Узбекистане может варьироваться, что приводит 
                  к образованию сажи и засорению горелочного устройства.
                </p>
                <p>
                  Также распространена проблема с датчиком ионизации пламени – он контролирует наличие пламени 
                  и в случае загрязнения может ошибочно сигнализировать об отсутствии горения, 
                  что приводит к блокировке котла.
                </p>

                <h3>4. Износ основных узлов</h3>
                <p>
                  Теплообменник, вентилятор, трёхходовой клапан, расширительный бак – все эти компоненты имеют 
                  ограниченный срок службы. При интенсивной эксплуатации (особенно в отопительный сезон) 
                  эти узлы изнашиваются и требуют замены.
                </p>

                <h3>5. Проблемы с дымоходом и вентиляцией</h3>
                <p>
                  Засорение дымохода, обратная тяга, неправильная установка дымохода – всё это может привести 
                  к аварийному отключению котла системой безопасности. Особенно это актуально для старых домов 
                  в Ташкенте, где вентиляционные системы могут быть в неудовлетворительном состоянии.
                </p>

                <h2>Признаки, что вашему котлу срочно нужен ремонт</h2>
                <p>
                  Важно распознать проблему на ранней стадии, чтобы избежать дорогостоящего ремонта или замены котла. 
                  Обратите внимание на следующие симптомы:
                </p>
                
                <ul className="warning-list">
                  <li><AlertCircle size={20} /> <strong>Котёл не включается</strong> – проблема может быть в электронике, газовом клапане или системе розжига</li>
                  <li><AlertCircle size={20} /> <strong>Котёл часто отключается</strong> – возможны проблемы с датчиками, перегрев, недостаточное давление</li>
                  <li><AlertCircle size={20} /> <strong>Странные звуки</strong> – шум, треск, гудение могут указывать на накипь в теплообменнике, проблемы с насосом</li>
                  <li><AlertCircle size={20} /> <strong>Запах газа</strong> – немедленно перекройте газ и вызовите специалиста!</li>
                  <li><AlertCircle size={20} /> <strong>Снижение мощности</strong> – дом не прогревается до нужной температуры</li>
                  <li><AlertCircle size={20} /> <strong>Увеличение расхода газа</strong> – признак неэффективной работы оборудования</li>
                  <li><AlertCircle size={20} /> <strong>Протечки воды</strong> – могут быть в теплообменнике, трубах, кранах</li>
                  <li><AlertCircle size={20} /> <strong>Коды ошибок на дисплее</strong> – система диагностики сигнализирует о конкретных проблемах</li>
                </ul>

                <h2>Как проходит профессиональный ремонт газового котла</h2>
                <p>
                  Компания Servis Pro использует проверенную методологию ремонта газовых котлов, 
                  которая гарантирует качественный результат и безопасность эксплуатации:
                </p>

                <div className="process-steps">
                  <div className="process-step">
                    <div className="step-number">1</div>
                    <h4>Первичный звонок и диспетчеризация</h4>
                    <p>
                      Вы звоните нам по телефону +998 90 488 63 33 или оставляете заявку через сайт. 
                      Диспетчер уточняет симптомы проблемы, марку и модель котла, адрес. 
                      Мастер выезжает в течение 1-2 часов, в срочных случаях – быстрее.
                    </p>
                  </div>

                  <div className="process-step">
                    <div className="step-number">2</div>
                    <h4>Диагностика на месте</h4>
                    <p>
                      Специалист проводит визуальный осмотр котла, проверяет работу всех систем, 
                      считывает коды ошибок, измеряет давление газа и воды, проверяет тягу. 
                      Используем профессиональное диагностическое оборудование для точного определения неисправности.
                    </p>
                  </div>

                  <div className="process-step">
                    <div className="step-number">3</div>
                    <h4>Составление сметы</h4>
                    <p>
                      После диагностики мастер озвучивает точную причину поломки и стоимость ремонта. 
                      Цена фиксируется и не меняется в процессе работы. Если требуются запчасти, 
                      которых нет у мастера, согласовываем сроки их доставки.
                    </p>
                  </div>

                  <div className="process-step">
                    <div className="step-number">4</div>
                    <h4>Ремонтные работы</h4>
                    <p>
                      После вашего согласия мастер приступает к ремонту. В большинстве случаев ремонт 
                      выполняется в день обращения. Используем только оригинальные или качественные 
                      сертифицированные запчасти. Все работы ведутся с соблюдением техники безопасности.
                    </p>
                  </div>

                  <div className="process-step">
                    <div className="step-number">5</div>
                    <h4>Тестирование и настройка</h4>
                    <p>
                      После завершения ремонта котёл запускается, проверяется работа всех режимов, 
                      настраиваются параметры для оптимальной работы. Мастер проверяет отсутствие утечек, 
                      правильность горения, работу автоматики безопасности.
                    </p>
                  </div>

                  <div className="process-step">
                    <div className="step-number">6</div>
                    <h4>Гарантия и рекомендации</h4>
                    <p>
                      Выдаём гарантийный талон на выполненные работы и установленные запчасти. 
                      Мастер даёт рекомендации по эксплуатации и обслуживанию котла, 
                      чтобы избежать проблем в будущем.
                    </p>
                  </div>
                </div>

                <h2>Почему стоит выбрать Servis Pro для ремонта газового котла в Ташкенте</h2>
                <p>
                  На рынке услуг по ремонту газовых котлов в Ташкенте работает множество мастеров и компаний. 
                  Почему же стоит доверить ремонт вашего котла именно нам?
                </p>

                <div className="advantages-grid">
                  <div className="advantage-card">
                    <Wrench size={32} />
                    <h4>Опыт и квалификация</h4>
                    <p>
                      Наши специалисты имеют многолетний опыт работы с газовым оборудованием. 
                      Каждый мастер прошёл обучение и сертификацию, имеет допуск к работе с газовым оборудованием. 
                      Мы постоянно повышаем квалификацию, изучаем новые модели котлов и технологии ремонта.
                    </p>
                  </div>

                  <div className="advantage-card">
                    <Clock size={32} />
                    <h4>Быстрый выезд 24/7</h4>
                    <p>
                      Мы понимаем, что поломка котла зимой – это не просто неудобство, а настоящая проблема. 
                      Поэтому работаем круглосуточно без выходных и праздников. Выезжаем в любой район Ташкента 
                      и пригороды в течение 1-2 часов после вашего звонка.
                    </p>
                  </div>

                  <div className="advantage-card">
                    <Shield size={32} />
                    <h4>Гарантия качества</h4>
                    <p>
                      На все виды работ предоставляем официальную гарантию от 6 месяцев до 2 лет. 
                      Если в течение гарантийного срока возникнет проблема, связанная с нашей работой, 
                      мы бесплатно устраним её. Гарантия распространяется и на установленные запчасти.
                    </p>
                  </div>

                  <div className="advantage-card">
                    <CheckCircle size={32} />
                    <h4>Оригинальные запчасти</h4>
                    <p>
                      Работаем только с оригинальными запчастями от производителей или качественными аналогами 
                      от проверенных поставщиков. Имеем собственный склад наиболее востребованных комплектующих, 
                      что позволяет выполнить ремонт в день обращения.
                    </p>
                  </div>

                  <div className="advantage-card">
                    <Phone size={32} />
                    <h4>Честные цены</h4>
                    <p>
                      Наши цены конкурентны и прозрачны. Стоимость озвучивается после диагностики и фиксируется. 
                      Никаких скрытых платежей или доплат. Диагностика при заказе ремонта – бесплатно. 
                      Оплата производится после выполнения работ и вашей проверки.
                    </p>
                  </div>

                  <div className="advantage-card">
                    <CheckCircle size={32} />
                    <h4>Работа с любыми брендами</h4>
                    <p>
                      Ремонтируем газовые котлы всех популярных марок: Baxi, Navien, Ariston, Bosch, Ferroli, 
                      Vaillant, Beretta, Immergas, Protherm, Viessmann и многие другие. Знаем особенности 
                      каждого бренда и типичные проблемы конкретных моделей.
                    </p>
                  </div>
                </div>

                <h2>Сравнение с конкурентами</h2>
                <div className="comparison-table-wrapper">
                  <table className="comparison-table">
                    <thead>
                      <tr>
                        <th>Параметр</th>
                        <th className="highlight">Servis Pro</th>
                        <th>Типичный конкурент</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Время выезда</td>
                        <td className="highlight">1-2 часа</td>
                        <td>На следующий день</td>
                      </tr>
                      <tr>
                        <td>График работы</td>
                        <td className="highlight">24/7</td>
                        <td>9:00-18:00 будни</td>
                      </tr>
                      <tr>
                        <td>Диагностика</td>
                        <td className="highlight">Бесплатно при ремонте</td>
                        <td>150 000 - 200 000 сум</td>
                      </tr>
                      <tr>
                        <td>Гарантия</td>
                        <td className="highlight">До 2 лет</td>
                        <td>1-3 месяца</td>
                      </tr>
                      <tr>
                        <td>Запчасти</td>
                        <td className="highlight">Оригинальные</td>
                        <td>Аналоги</td>
                      </tr>
                      <tr>
                        <td>Квалификация</td>
                        <td className="highlight">Сертифицированные мастера</td>
                        <td>Частные мастера</td>
                      </tr>
                      <tr>
                        <td>Цена за базовый ремонт</td>
                        <td className="highlight">от 199 000 сум</td>
                        <td>от 250 000 сум</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h2>Безопасность при ремонте газового оборудования</h2>
                <p>
                  Газовый котёл – это источник потенциальной опасности. Природный газ при утечке может привести 
                  к отравлению, взрыву или пожару. Поэтому ремонт газового оборудования должны выполнять только 
                  квалифицированные специалисты с соответствующим допуском.
                </p>
                <p>
                  Все наши мастера имеют необходимые сертификаты и разрешения на работу с газовым оборудованием. 
                  При выполнении ремонта строго соблюдаются правила техники безопасности, используется 
                  специализированное оборудование для обнаружения утечек газа.
                </p>
                <p>
                  После завершения ремонта обязательно проводится проверка герметичности всех газовых соединений, 
                  правильности настройки горелки, работы системы отвода продуктов сгорания. 
                  Только после успешного тестирования котёл передаётся заказчику.
                </p>

                <h2>Профилактика – лучше, чем ремонт</h2>
                <p>
                  Чтобы минимизировать риск поломок и продлить срок службы вашего газового котла, 
                  рекомендуем проводить регулярное техническое обслуживание:
                </p>
                <ul>
                  <li>Ежегодная профилактическая чистка и настройка перед отопительным сезоном</li>
                  <li>Проверка и очистка теплообменника от накипи</li>
                  <li>Контроль давления в системе и расширительном баке</li>
                  <li>Проверка герметичности соединений</li>
                  <li>Очистка датчиков и электродов</li>
                  <li>Проверка дымохода и вентиляции</li>
                </ul>
                <p>
                  Стоимость регулярного обслуживания значительно ниже, чем стоимость ремонта вышедшего из строя 
                  котла. Кроме того, правильное обслуживание снижает расход газа на 10-15%, 
                  что окупает затраты на профилактику.
                </p>

                <h2>Часто задаваемые вопросы о ремонте газовых котлов</h2>
                
                <div className="faq-detailed">
                  <div className="faq-item-detailed">
                    <h3>Сколько времени занимает ремонт газового котла?</h3>
                    <p>
                      Время ремонта зависит от характера неисправности. Простой ремонт (замена датчика, чистка форсунок) 
                      может быть выполнен за 1-2 часа. Сложный ремонт с заменой теплообменника или платы управления 
                      может занять 3-5 часов. Если требуется заказ редких запчастей, ремонт может растянуться на 1-3 дня. 
                      В любом случае, мастер озвучит точные сроки после диагностики.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Можно ли отремонтировать очень старый котёл?</h3>
                    <p>
                      В большинстве случаев – да. Однако для котлов старше 15 лет может быть проблема с поиском запчастей. 
                      Также важно оценить экономическую целесообразность: иногда дорогостоящий ремонт старого котла 
                      менее выгоден, чем покупка нового современного оборудования с лучшей эффективностью. 
                      Наш мастер даст честную рекомендацию после осмотра.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Что делать, если котёл на гарантии производителя?</h3>
                    <p>
                      Если ваш котёл находится на гарантии производителя, рекомендуем сначала обратиться в авторизованный 
                      сервисный центр. Однако учтите, что гарантийный ремонт может занять много времени, 
                      особенно в отопительный сезон. Если вам нужен срочный ремонт, мы можем выполнить его, 
                      но это может привести к аннулированию гарантии производителя.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Работаете ли вы с промышленными котлами?</h3>
                    <p>
                      Да, наша компания выполняет ремонт и обслуживание не только бытовых, но и промышленных котлов, 
                      котельных установок. У нас есть специалисты с опытом работы с крупногабаритным оборудованием. 
                      Для промышленных объектов предлагаем заключение договоров на регулярное обслуживание.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Какие документы вы предоставляете после ремонта?</h3>
                    <p>
                      После завершения ремонта мы выдаём акт выполненных работ с детальным описанием проведённых операций 
                      и использованных запчастей, гарантийный талон, чек об оплате. При необходимости можем предоставить 
                      сертификаты на установленные запчасти.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Даёте ли вы рекомендации по выбору нового котла?</h3>
                    <p>
                      Да, если ваш котёл не подлежит ремонту или ремонт экономически нецелесообразен, 
                      наш специалист бесплатно проконсультирует вас по выбору нового оборудования, 
                      подходящего для ваших условий и бюджета. Также предоставляем услуги по установке новых котлов.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Как часто нужно проводить техническое обслуживание котла?</h3>
                    <p>
                      Производители рекомендуют проводить полное техническое обслуживание газового котла минимум 
                      один раз в год, желательно перед началом отопительного сезона (в сентябре-октябре). 
                      Если котёл эксплуатируется интенсивно или вода в вашем регионе очень жёсткая, 
                      может потребоваться обслуживание дважды в год.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Что входит в стоимость ремонта?</h3>
                    <p>
                      В стоимость ремонта входит: выезд мастера, диагностика, работа по устранению неисправности, 
                      настройка и тестирование котла. Запчасти оплачиваются отдельно по фактическим ценам. 
                      Все расценки озвучиваются до начала работ и фиксируются.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Могу ли я присутствовать при ремонте?</h3>
                    <p>
                      Конечно! Мы приветствуем присутствие заказчика при выполнении работ. 
                      Мастер прокомментирует каждый этап ремонта, покажет найденную неисправность, 
                      объяснит причины её возникновения. Это помогает лучше понять проблему и избежать её в будущем.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Что делать, если после ремонта проблема вернулась?</h3>
                    <p>
                      Если в течение гарантийного срока возникла та же проблема, немедленно свяжитесь с нами. 
                      Мы бесплатно приедем и устраним неисправность. Если проблема повторяется, возможно, 
                      есть дополнительная скрытая причина, которую мы обязательно найдём и устраним. 
                      Гарантия – это не просто формальность для нас, это наша ответственность перед клиентом.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Выезжаете ли вы за пределы Ташкента?</h3>
                    <p>
                      Да, мы работаем не только в Ташкенте, но и в пригородах и ближайших регионах. 
                      Стоимость выезда за пределы города рассчитывается индивидуально в зависимости от расстояния. 
                      Уточните этот момент при заказе услуги у нашего диспетчера.
                    </p>
                  </div>

                  <div className="faq-item-detailed">
                    <h3>Принимаете ли вы оплату картой?</h3>
                    <p>
                      Да, мы принимаем оплату как наличными, так и безналичным расчётом (переводом на карту). 
                      Для юридических лиц возможна оплата по счёту с предоставлением всех необходимых документов.
                    </p>
                  </div>
                </div>

                <h2>Заключение</h2>
                <p>
                  Ремонт газового котла – это задача, требующая профессионального подхода, опыта и специального оборудования. 
                  Компания Servis Pro предлагает комплексные услуги по ремонту и обслуживанию газовых котлов в Ташкенте 
                  и Узбекистане с гарантией качества и по конкурентным ценам.
                </p>
                <p>
                  Мы работаем прозрачно: озвучиваем точную стоимость после диагностики, используем качественные запчасти, 
                  выполняем работу быстро и с гарантией. Наша цель – не просто починить ваш котёл, 
                  а сделать это качественно, безопасно и с заботой о долгосрочной работе оборудования.
                </p>
                <p>
                  Если у вас возникли проблемы с газовым котлом, не откладывайте ремонт. 
                  Чем раньше устранить неисправность, тем дешевле обойдётся ремонт и меньше риск полного выхода оборудования из строя.
                </p>
                <p className="final-cta-text">
                  <strong>Звоните прямо сейчас: +998 90 488 63 33</strong><br />
                  Или оставьте заявку на сайте, и мы перезвоним вам в течение 5 минут!
                </p>
              </div>

              <aside className="sidebar">
                <div className="sticky-sidebar">
                  <ContactForm className="sidebar-form" />
                  
                  <div className="sidebar-info">
                    <h4>Почему нам доверяют</h4>
                    <ul className="trust-list">
                      <li><CheckCircle size={18} /> Более 500 выполненных ремонтов</li>
                      <li><CheckCircle size={18} /> Средний рейтинг 4.9/5</li>
                      <li><CheckCircle size={18} /> 98% клиентов рекомендуют нас</li>
                      <li><CheckCircle size={18} /> Работаем с 2015 года</li>
                    </ul>
                  </div>

                  <div className="sidebar-emergency">
                    <h4>Срочный ремонт?</h4>
                    <p>Мы работаем 24/7</p>
                    <a href="tel:+998904886333" className="btn-primary">
                      <Phone size={18} />
                      Позвонить сейчас
                    </a>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        {/* Related Services */}
        <section className="related-services">
          <div className="container">
            <h2>Другие наши услуги</h2>
            <div className="services-grid">
              {services.filter(s => s.id !== serviceId).slice(0, 3).map(relatedService => (
                <Link 
                  key={relatedService.id}
                  to={`/services/${relatedService.id}`}
                  className="service-card"
                >
                  <h3>{relatedService.title}</h3>
                  <p>{relatedService.shortDesc}</p>
                  <div className="service-price">
                    <span className="price-label">от</span>
                    <span className="price-value">{relatedService.price}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  }

  // Standard service page for other services
  return (
    <div className="service-page">
      <div className="breadcrumbs">
        <div className="container">
          <Link to="/">Главная</Link> / <Link to="/services">Услуги</Link> / <span>{service.title}</span>
        </div>
      </div>

      <section className="service-hero">
        <div className="container">
          <h1>{service.title}</h1>
          <p className="service-lead">{service.shortDesc}</p>
          <div className="service-cta-buttons">
            <a href="tel:+998904886333" className="btn-primary">
              <Phone size={20} />
              Заказать услугу
            </a>
            <span className="price-highlight">Цена {service.price}</span>
          </div>
        </div>
      </section>

      <section className="service-content">
        <div className="container">
          <div className="content-layout">
            <div className="main-content">
              <h2>О услуге</h2>
              <p>
                Профессиональная услуга "{service.title}" от компании Servis Pro в Ташкенте. 
                Наши специалисты имеют большой опыт работы с газовым оборудованием всех марок.
              </p>
              <p>
                Мы используем современное оборудование и оригинальные запчасти, 
                что гарантирует высокое качество выполненных работ. Все работы выполняются 
                с соблюдением техники безопасности и норм эксплуатации газового оборудования.
              </p>

              <h3>Преимущества нашей услуги</h3>
              <ul>
                <li>Быстрый выезд мастера в течение 1-2 часов</li>
                <li>Работаем 24/7 без выходных</li>
                <li>Гарантия на выполненные работы</li>
                <li>Оригинальные запчасти</li>
                <li>Конкурентные цены</li>
                <li>Опытные сертифицированные специалисты</li>
              </ul>

              <h3>Как мы работаем</h3>
              <div className="process-steps">
                <div className="process-step">
                  <div className="step-number">1</div>
                  <h4>Звонок</h4>
                  <p>Вы звоните нам или оставляете заявку на сайте</p>
                </div>
                <div className="process-step">
                  <div className="step-number">2</div>
                  <h4>Выезд мастера</h4>
                  <p>Специалист приезжает в течение 1-2 часов</p>
                </div>
                <div className="process-step">
                  <div className="step-number">3</div>
                  <h4>Диагностика</h4>
                  <p>Проводим полную диагностику оборудования</p>
                </div>
                <div className="process-step">
                  <div className="step-number">4</div>
                  <h4>Выполнение работ</h4>
                  <p>Выполняем необходимые работы качественно и быстро</p>
                </div>
                <div className="process-step">
                  <div className="step-number">5</div>
                  <h4>Гарантия</h4>
                  <p>Выдаём гарантию на выполненные работы</p>
                </div>
              </div>

              <h3>Часто задаваемые вопросы</h3>
              <div className="faq-list">
                <details className="faq-item">
                  <summary>Сколько времени занимает выполнение работ?</summary>
                  <p>
                    Время выполнения зависит от сложности работ. Обычно от 1 до 4 часов. 
                    Точные сроки мастер озвучит после диагностики.
                  </p>
                </details>
                <details className="faq-item">
                  <summary>Какая гарантия на работы?</summary>
                  <p>
                    Мы предоставляем гарантию от 6 месяцев до 2 лет в зависимости от типа работ 
                    и используемых запчастей.
                  </p>
                </details>
                <details className="faq-item">
                  <summary>Работаете ли вы в выходные?</summary>
                  <p>
                    Да, мы работаем 24/7 включая выходные и праздничные дни.
                  </p>
                </details>
                <details className="faq-item">
                  <summary>Какие марки котлов вы обслуживаете?</summary>
                  <p>
                    Мы работаем со всеми популярными марками: Baxi, Navien, Ariston, Bosch, 
                    Ferroli, Vaillant и другими.
                  </p>
                </details>
                <details className="faq-item">
                  <summary>Сколько стоит диагностика?</summary>
                  <p>
                    Диагностика стоит от 99 000 сум. При заказе ремонта диагностика бесплатно.
                  </p>
                </details>
              </div>
            </div>

            <aside className="sidebar">
              <div className="sticky-sidebar">
                <ContactForm className="sidebar-form" />
                
                <div className="sidebar-info">
                  <h4>Стоимость услуги</h4>
                  <p className="sidebar-price">{service.price}</p>
                  <p className="sidebar-note">* Итоговая стоимость зависит от объёма работ</p>
                </div>

                <div className="sidebar-emergency">
                  <h4>Нужна срочная помощь?</h4>
                  <a href="tel:+998904886333" className="btn-primary">
                    <Phone size={18} />
                    Позвонить
                  </a>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicePage;
